import type { NewsEntry } from "./news-types";

/**
 * Pinned news entries (not overwritten by generate-news-entries.mjs).
 * Add new manual announcements at the TOP of this array.
 */
export const MANUAL_NEWS_ENTRIES: NewsEntry[] = [
    {
        id: "2026-11-03-cursor-soccer-mega",
        date: "2026-11-03",
        title: "Cursor Soccer: MEGA FIELD + What's New",
        description:
            "Compete and Multiplayer Soccer now offer NORMAL and MEGA FIELD: a much larger pitch, 3-minute matches, speed-capped movement, left-click boost (PC) or the boost toggle on mobile, and gold or teal boost pickups in the corners and midfield. Pick your variant after 1v1/2v2 in Compete; hosts can set MEGA in Multiplayer before team select. Check What's New in the menu for the full list.",
        category: "gameplay",
    },
    {
        id: "2026-11-02-cursor-soccer",
        date: "2026-11-02",
        title: "Cursor Soccer: Compete, Multiplayer, and Local",
        description:
            "New Cursor Soccer hub under START → PLAY → Compete (its own category, not inside Modes): 1v1 or 2v2 matchmaking with queue counts. Also in Multiplayer rooms and Local (2–4 players on one device). Top-down pitch, team blue vs orange, 5-minute matches, goal replays, overtime on ties, match stats and rematch. Compete assigns teams randomly with no team picker; Multiplayer and Local let you pick teams before kickoff and change team from the in-game MENU (not in Compete).",
        category: "gameplay",
    },
    {
        id: "2026-11-02-play-hub-marathon",
        date: "2026-11-02",
        title: "PLAY hub: Marathon returns, cleaner category cards",
        description:
            "START → PLAY categories no longer show long descriptions under each title — just the category name and art. Marathon is back under Compete (next to Tournaments): chain admin-configured mode legs in one run, progress HUD, personal best, and leaderboard. Admins edit the sequence under Admin Panel → Marathon; custom hub icons still include a Marathon slot.",
        category: "gameplay",
    },
    {
        id: "2026-11-02-mp-remote-theme-cursor",
        date: "2026-11-02",
        title: "Multiplayer: remote cursors ignore Theme cosmetics",
        description:
            "Other players no longer see your equipped Theme preview art on your cursor in Multiplayer or Loot Drops — only your hat, face, cursor, and trail cosmetics show on remotes, matching how Themes work on your own screen.",
        category: "bug-fix",
    },
    {
        id: "2026-08-08-sidebar-streak-refresh",
        date: "2026-08-08",
        title: "Play streak updates in the sidebar",
        description:
            "With Settings → Show Streak off, the play streak lives in the menu sidebar. Playing a mode now lights and increments that sidebar streak the same day — it no longer stayed dim until you toggled the setting or refreshed Home.",
        category: "bug-fix",
    },
    {
        id: "2026-08-07-tournaments",
        date: "2026-08-07",
        title: "Tournaments: bracket competition",
        description:
            "START → Tournaments opens a new hub category. Browse a large scrollable list (Live → Upcoming → Ended), register for upcoming events, and climb single-elimination brackets with a different mode per match. Matches are async: each player runs their own attempt; highest score advances. Join windows are 5 minutes, forfeit on no-show, ties restart after 10 seconds. Admins create brackets (4–32), set per-match modes and Dots rewards, and can schedule Daily / Hourly / Weekly recurring templates under Admin Panel → Tournaments.",
        category: "gameplay",
    },
    {
        id: "2026-08-05-exclusive-menu-panels",
        date: "2026-08-05",
        title: "Only one menu panel open at a time",
        description:
            "Opening Notifications, Social, Settings, Admin Panel, News, Wall, or any similar menu screen now closes any other open panel first, so overlays no longer stack on top of each other.",
        category: "bug-fix",
    },
    {
        id: "2026-08-03-sent-items-delete-item",
        date: "2026-08-03",
        title: "Sent Items: Delete Item",
        description:
            "Sent Items now has Delete Item to permanently remove a sent cosmetic from the list, the catalog, and every user’s inventory (unlike Delete for all, which only revokes ownership).",
        category: "gameplay",
    },
    {
        id: "2026-08-03-inventory-index",
        date: "2026-08-03",
        title: "Inventory Index: collect every cosmetic",
        description:
            "Inventory gains an Index tab — a full catalog of every published cosmetic (Shop, Crates, and Campaign rewards), including limited editions after they leave the Shop. Items you own show in color with their unlock path; ones you don’t are black silhouettes that reveal on hover/hold with how to get them. Filter by All, Obtained, or Not Obtained. Index is browse-only — equip still happens from Cosmetics.",
        category: "gameplay",
    },
    {
        id: "2026-08-01-delay-mode",
        date: "2026-08-01",
        title: "DELAY mode: ghost now, real later",
        description:
            "New singleplayer mode DELAY: steer a faint ghost cursor with no collision and no cosmetics. Your real cursor (full cosmetics) replays that exact path with a fixed 1-second delay — only it can die on balls. Both start together; the real cursor stays put for the first 1 second. Same Normal spawns and survival score. Live in Modes, Rankings, Stats, Sandbox, Challenges, and News.",
        category: "gameplay",
    },
    {
        id: "2026-08-01-challenges-square-bottom-out",
        date: "2026-08-01",
        title: "Challenges square: bottoms out and snaps",
        description:
            "Pushing the blue Daily Challenges square now shatters the moment the dent bottoms out at its deepest point — no timer, just keep pressing until the wall gives. The dent stays glued to your cursor as you press, so slow and fast pushes reach the bottom the same way, and red still caps out and springs back without ever letting you through. Sliding along the sides and corners no longer snaps or traps the cursor.",
        category: "gameplay",
    },
    {
        id: "2026-07-31-gamepad-support",
        date: "2026-07-31",
        title: "Full gamepad support",
        description:
            "Play and navigate CursorGame with a Standard Gamepad (Xbox, PlayStation, and compatible pads). Auto-detect with a connect toast; left stick moves the cursor (D-Pad in WASD); face buttons map to Superdot skills; Hook aims with the right stick and fires with RT/A; AIM, Counter, and Golf use RT or A to confirm. Pause on Start, Return on Back, hold RB to quick-restart. Touch overlays hide while a pad is connected. New Settings → Gamepad section (when connected) for sensitivity, deadzone, and remaps. Menus are fully navigable with stick/D-Pad focus and A/B.",
        category: "gameplay",
    },
    {
        id: "2026-07-31-campaign",
        date: "2026-07-31",
        title: "Campaign: climb the node tree",
        description:
            "START → Campaign opens a branching node tree. Each node is a mode + goal (score or time). Clear available nodes to unlock the next branches; the final node is larger. First clear grants Dots or an exclusive cosmetic (admin-configured). Retry completed nodes anytime with no extra reward. Entry uses the ink play transition (CursorGame easter egg) then a Challenges-style mode + Goal reveal. Admins get a Campaign tree editor under Admin Panel.",
        category: "gameplay",
    },
    {
        id: "2026-07-30-shop-hold-to-buy",
        date: "2026-07-30",
        title: "Shop: hold to BUY / Claim",
        description:
            "Buying or claiming in the Shop (Items, Trails, Banners, Crates) now needs a 3-second hold. A radial ring fills while you press, with a rising charge tone; release early to cancel (ring drains + short descending SFX). Completing the hold confirms the purchase with a new chime, then runs the usual buy/claim flow.",
        category: "gameplay",
    },
    {
        id: "2026-07-30-home-settings-layout",
        date: "2026-07-30",
        title: "Settings → Home: widgets & layout",
        description:
            "New Settings → Home section gathers Show News, Show Notifications, and Show Splash Texts, plus toggles for Friends, Last Mode, Trending Mode, Dots, Streak (or sidebar), Challenge Status, Active LootDrops, New in Shop, Suggested Mode, Continue Playing, and Cursor Bounce. Customize Layout lets you drag/resize Home widgets and START with center snapping (Shift or mobile toggle to move freely); Reset Layout restores defaults. Layout and toggles sync with your account when signed in.",
        category: "settings",
    },
    {
        id: "2026-07-28-shop-send-to",
        date: "2026-07-28",
        title: "Shop Creator: Send to",
        description:
            "Publish → Save as → Send to gifts a cosmetic to chosen users without listing it in the Shop. Shop Items → Sent Items lists those gifts with Edit, Publish to Shop/Crates, Delete for all (inventories only), and Delete Item (permanent catalog + inventory wipe).",
        category: "gameplay",
    },
    {
        id: "2026-07-27-hold-return-home-orbit-lives",
        date: "2026-07-27",
        title: "Hold Return for Home · ORBIT lives fix",
        description:
            "Hold the Return keybind (default H) or the on-screen Return button to jump straight to Home — short press still steps back one screen. Toggle and hold duration live under Settings → Accessibility (default 1s, adjustable). Also: ORBIT core lives keep the same size and spacing on phones/tablets as on PC (no extra layout scaling).",
        category: "settings",
    },
    {
        id: "2026-07-27-ink-play-transition",
        date: "2026-07-27",
        title: "Ink blot play transition",
        description:
            "The optional Play transition is now an organic ink blot in your button color that expands from where you tap — on Home START into the Game Hub, and when a run starts from Modes, Sandbox, Multiplayer, or Local. Same Settings toggle; turn it OFF for an instant cut.",
        category: "visual",
    },
    {
        id: "2026-07-27-challenges-square-deform",
        date: "2026-07-27",
        title: "Challenges square: push, squash, shatter",
        description:
            "The Daily Challenges neon square reacts when you near or push its outline: the touched edge lights up, sinks inward with a soft elastic rebound, and — when the square is blue — breaks open with a shatter SFX before the usual 3s fade into the mode roulette. Red (locked) still squashes and bounces back but never breaks or lets you in.",
        category: "visual",
    },
    {
        id: "2026-07-26-profile-banners-photo",
        date: "2026-07-26",
        title: "Wider Profiles, Banners & photo editor",
        description:
            "Profiles are wider with a flush photo+banner header, full visited-player Stats, Transfer Dots (both balances), friend add/remove, and Chat when you’re friends. Configure a profile photo from owned Cursor cosmetics (zoom/rotate/drag — separate from your play loadout). Shop/Crates Creator gains Banner cosmetics (wide canvas, text tool, up to 10 frames) under a new Banners shop category; equip them from Inventory or Profile.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-score-unlock-label-preserve",
        date: "2026-07-26",
        title: "Score unlock text stays specific",
        description:
            "Shop cards for score-unlock items keep labels like “Level 5 in Progression” after you rename or re-publish art. Editing name, drawing, or options no longer wipes the required mode and score.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-inventory-trail-color",
        date: "2026-07-26",
        title: "Inventory Trail Color",
        description:
            "Inventory’s right panel now has Trail Color RGB sliders under Cursor Color, with a live color line so you can see your trail tint before you play. It syncs with Settings → Trail Color.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-shop-creator-layers-symmetry",
        date: "2026-07-26",
        title: "Shop Creator: layers, symmetry cross, Duplicate",
        description:
            "Shop Creator and Crates Creator add a Symmetry cross guide for aligning art, unlimited paint Layers (Select only moves the active layer), and Duplicate on a Select selection. Same tools apply when publishing crate items.",
        category: "gameplay",
    },
    {
        id: "2026-07-25-new-cursor-cosmetics",
        date: "2026-07-25",
        title: "New Cursor cosmetics",
        description:
            "Shop/Crates Creator can mark a cosmetic as New Cursor: the filled play cursor is hidden and only your art shows (hitbox unchanged). Publish locks the category to Cursor. Crate hold/eye previews also hide the circle behind New Cursor drops.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-hook-laser-cursor-passthrough",
        date: "2026-07-26",
        title: "Hook laser matches cursor and passes through balls",
        description:
            "The Hook aim laser now uses your cursor color and draws straight to the arena edge through balls (no visual stop on contact). The flying hook still collects balls along the way and retracts at the wall.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-pc-pwa-touch-overlays",
        date: "2026-07-26",
        title: "Desktop install: mobile controls stay hidden",
        description:
            "Installed CursorGame on PC no longer shows mobile-only overlays (Hook aim joystick, D-Pad, and related touch chrome). Those stay on phones and tablets; desktop keeps mouse/keyboard controls.",
        category: "gameplay",
    },
    {
        id: "2026-07-26-orbit-mode",
        date: "2026-07-26",
        title: "New mode: ORBIT",
        description:
            "Defend a hollow core by rotating on its rim — A/D or ←/→ on PC, D-Pad left/right or a horizontal slide on mobile. Balls streak in from the edges; intercept them for a boom, or they breach the center and end the run. Difficulty ramps smoothly inside each 1000-score block. Fully wired into Modes, Rankings, Stats, Sandbox (unique orbit tunables), Challenges, and News.",
        category: "gameplay",
    },
    {
        id: "2026-07-24-limited-shop-items",
        date: "2026-07-24",
        title: "Limited Shop Items",
        description:
            "Shop Creator can mark cosmetics as Limited Item with a duration (1d, 2d 15h, …). Limited cards show ENDS IN … in the Shop; when time is up they stay dark and unbuyable for one week, then leave the listing. Admin Panel → Shop Items adds a Limited Items tab with Active and Ended sections.",
        category: "gameplay",
    },
    {
        id: "2026-07-24-challenges",
        date: "2026-07-24",
        title: "Daily Challenges",
        description:
            "PLAY → Challenges is live: enter the neon square for one attempt per local calendar day (12:00 AM in your account timezone, same day keys as Play Streaks). A server-picked mode roulette assigns your goal; beat it in a single life to spin for 500–10,000 Dots (weighted odds). Return asks “Sure?” before forfeiting. Admins configure mode templates and reward probabilities in Admin Panel → Challenges, and can reset everyone's daily attempt.",
        category: "gameplay",
    },
    {
        id: "2026-07-18-pop-mode",
        date: "2026-07-18",
        title: "New mode: POP",
        description:
            "Survive 50 large balls. Same-size collisions split into smaller, faster sizes; minis fuse into bigger balls. A 2s split cooldown applies at start and after each split. Fully integrated in Modes, Rankings, Stats, News, and Sandbox.",
        category: "gameplay",
    },
    {
        id: "2026-07-16-shop-crates",
        date: "2026-07-16",
        title: "Crates In Shop!",
        description:
            "Shop now has separate Items and Crates tabs. Published crates open instantly with a case-opening animation, can award any configured cosmetic by server-side drop chance, and duplicate drops from paid crates refund part of the crate price in Dots. Admin Panel adds Crates Creator plus a full Crates manager to draw crate art, assign contents, set probabilities, and publish or unpublish crate drafts.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-practice-creator",
        date: "2026-07-12",
        title: "Practice hub and Practice Creator",
        description:
            "START → Practice lists published drills with no score or rankings. Admins get Practice Creator (SpeedRun-style layouts plus balls, mechanics toggles, and Guide zones with step messages) and Practice Levels to publish, edit titles/descriptions/categories, or load drills into the canvas.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-tilt-mode",
        date: "2026-07-12",
        title: "New mode: TILT",
        description:
            "Survive like Normal while steering by tilting your phone or tablet — the cursor rolls with acceleration and inertia like a ball on a tilted table. Finger control is off; +25 balls every 500 score. On PC (or devices without motion sensors) you get “This mode is for Mobile Only” and the run does not start.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-cosmetic-categories-recolor",
        date: "2026-07-12",
        title: "Shop cosmetics: categories, outline, and purchase tint",
        description:
            "Cosmetics are grouped into Hat, Face, Cursor, and Cursor Color. Cursor Color cosmetics stay hidden in Color Rush, Heat, and other modes that force cursor color. Shop Creator has an Outline tool so recoloring skips those pixels. When Custom color is enabled, you pick a tint only while buying; repurchase (if allowed) lets you buy again to change it.",
        category: "visual",
    },
    {
        id: "2026-07-12-shop-creator-bucket-select",
        date: "2026-07-12",
        title: "Shop Creator: larger canvas, fixed bucket, Select tool",
        description:
            "Shop Creator opens at 8× zoom by default. Bucket fill now floods closed areas with one click. Toolbar groups Tool, Color, and Size separately. New Select tool: drag a box around pixels, then drag the selection to move them.",
        category: "visual",
    },
    {
        id: "2026-07-12-home-splash-setting-nowrap",
        date: "2026-07-12",
        title: "Home splash toggle and single-line text",
        description:
            "Splash lines under the Home title stay on one line even when long. Settings → Home splash texts can hide them. The splash sits a bit lower under the E.",
        category: "settings",
    },
    {
        id: "2026-07-23-play-streaks-local-calendar",
        date: "2026-07-23",
        title: "Play streaks follow your local calendar day",
        description:
            "Play streaks now use your account time zone's calendar day (like Duolingo): play any time before local midnight to keep the fire lit; at 12:00 AM the flame dims until you play again. Missing a full local day breaks the streak. Signed-in days are decided on the server with your stored time zone, so changing the device clock cannot farm streaks.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-server-dots",
        date: "2026-07-12",
        title: "Dots balance is server-authoritative",
        description:
            "Daily login Dots and run Dots rewards are granted on the server (UTC). Changing your device clock or editing local data cannot invent Dots when you are signed in.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-server-play-streaks",
        date: "2026-07-12",
        title: "Play streaks use server time when signed in",
        description:
            "Signed-in play streaks are recorded on the server with your account's local calendar days, so changing your device clock cannot farm consecutive-day streaks. Guests still track streaks locally on this device.",
        category: "gameplay",
    },
    {
        id: "2026-07-12-larger-play-streak-fire",
        date: "2026-07-12",
        title: "Larger play-streak fire icons",
        description:
            "Home and mode-card streak fires are bigger. Lit and dim states stay the same size so the icon does not jump when you play.",
        category: "visual",
    },
    {
        id: "2026-07-12-home-splash-texts",
        date: "2026-07-12",
        title: "Home splash texts",
        description:
            "Minecraft-style splash lines appear beside the Home title — tilted left, soft breathe scale, always in your text color. Admins edit an unlimited list under Admin Panel → Splash (one line per splash); a random splash is picked each time you return to Home.",
        category: "visual",
    },
    {
        id: "2026-07-11-play-streaks",
        date: "2026-07-11",
        title: "Daily play streaks on Home and Modes",
        description:
            "A pixel fire under the C on Home tracks consecutive days you play any mode — lit in orange/red/yellow after you play today, gray until you do, and resets if you miss a day. Each mode card has its own fire and streak in the top-right corner.",
        category: "gameplay",
    },
    {
        id: "2026-07-11-inventory-multi-equip",
        date: "2026-07-11",
        title: "Inventory and stackable cursor cosmetics",
        description:
            "New Inventory sidebar screen to equip or unequip owned cosmetics — you can wear many at once. Shop cards show large cosmetic previews with a hover cursor preview; Shop Creator has undo/redo.",
        category: "gameplay",
    },
    {
        id: "2026-07-11-shop-dots-cosmetics",
        date: "2026-07-11",
        title: "Shop, Dots currency, and cursor cosmetics",
        description:
            "New Shop in the sidebar: browse cursor cosmetics, preview them on a live cursor, and buy with Dots or claim via achievements, challenges, or score goals. Dots come from daily login streaks, achievements, and post-run score rewards. Admins get Shop Creator and Shop Items in the Admin Panel. Game Over shows Dots earned (sign in required).",
        category: "gameplay",
    },
    {
        id: "2026-07-11-switch-account-trash-unlink",
        date: "2026-07-11",
        title: "Switch Account panel size and remove button",
        description:
            "Switch Account is taller and a bit wider. Each saved account has a red trash button; removing an account unlinks both ways so neither profile lists the other anymore.",
        category: "gameplay",
    },
    {
        id: "2026-07-11-mode-panel-title-fit-fix",
        date: "2026-07-11",
        title: "Mode panel titles always show in full",
        description:
            "Fixed title clipping in the Modes selection panel. Names like Progression now shrink to fit the panel width so the full word stays readable on one line.",
        category: "visual",
    },
    {
        id: "2026-07-10-mode-panel-title-auto-fit",
        date: "2026-07-10",
        title: "Mode panel titles shrink to fit",
        description:
            "Long mode names such as Progression, Multiplayer, and Color Rush now auto-scale in the selection panel so the full title stays on one line without clipping.",
        category: "visual",
    },
    {
        id: "2026-07-10-play-hub-monochrome-art",
        date: "2026-07-10",
        title: "PLAY hub monochrome card art and layout",
        description:
            "Game Hub category cards use minimal monochrome SVG illustrations synced to your theme. The card row sits lower on the screen for a cleaner PLAY screen.",
        category: "visual",
    },
    {
        id: "2026-07-10-play-hub-horizontal-cards-mp-local",
        date: "2026-07-10",
        title: "Tall horizontal PLAY hub cards; MP and Local moved",
        description:
            "PLAY hub cards are now wide horizontal tiles with title and description. Multiplayer and Local live only in the hub — they no longer appear as mode cards in the Modes list.",
        category: "gameplay",
    },
    {
        id: "2026-07-10-retap-selected-mode-starts",
        date: "2026-07-10",
        title: "Re-tap a selected mode card to start",
        description:
            "With the mode select panel on, tapping the already-selected card starts the run immediately — same as pressing the circular PLAY button.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-softer-play-transition",
        date: "2026-07-09",
        title: "Softer play transition blur and audio",
        description:
            "The optional Modes play transition now blurs and darkens the screen while fading game music through a low-pass filter instead of a hard black cut.",
        category: "visual",
    },
    {
        id: "2026-07-09-larger-modes-play-button",
        date: "2026-07-09",
        title: "Larger circular PLAY button on Modes panel",
        description:
            "The Modes selection panel PLAY circle is bigger and easier to hit on touch screens while keeping the 3D hover and press animations.",
        category: "visual",
    },
    {
        id: "2026-07-10-game-hub-play-categories",
        date: "2026-07-10",
        title: "PLAY hub with Modes, Practice, Multiplayer, Local, and Challenges",
        description:
            "START now opens a Game Hub with large category cards. Modes keeps the full searchable list; Multiplayer and Local open their existing screens; Practice and Challenges are placeholders for upcoming content.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-modes-panel-play-transition-settings",
        date: "2026-07-09",
        title: "Mode panel + play transition toggles in Settings",
        description:
            "Settings → Gameplay: turn OFF Mode select panel to start a run with one card tap again. Play transition adds a 2-second black fade with distant music when starting from Modes — also optional.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-custom-scrollbars-touch-overlay-fps",
        date: "2026-07-09",
        title: "Custom scrollbars, lighter mode hovers, touch overlay fix",
        description:
            "All scrollable panels use a minimal CursorGame scrollbar synced to your button color (mouse drag and touch). Mode card hover FX are lighter for steadier FPS. D-Pad no longer appears in WASD or Roulette on PC; Hook aim joystick is mobile-only again.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-modes-panel-polish-3d-play",
        date: "2026-07-09",
        title: "Modes panel polish: 3D PLAY, hover FX, deselect",
        description:
            "The mode info panel adds ambient glow, sparkles, and UI sounds for select, switch, deselect, and PLAY. The circular PLAY button is centered with a 3D lift toward you on hover, a drop shadow behind it, and a press-in sink on click. Mode titles in the panel are larger. Tap a selected card again to deselect. Mode cards glow brighter on hover with shimmer, scale, and color.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-modes-select-then-play-panel",
        date: "2026-07-09",
        title: "Modes: select first, PLAY to start",
        description:
            "Tapping a mode card only selects it — a panel slides in on the right with a short description and an animated circular PLAY button to begin. The selected card glows with your button color; switch modes anytime without leaving the screen.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-local-card-square-mp-grid",
        date: "2026-07-09",
        title: "LOCAL card back on mobile beside Multiplayer",
        description:
            "On phones and tablets, LOCAL appears again as a square card to the right of Multiplayer in Modes. Desktop PC still hides it.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-switch-account-isolated-stats",
        date: "2026-07-09",
        title: "Switch Account loads each profile separately",
        description:
            "Switching accounts shows the Loading screen, clears local stats and session data while the swap runs, then loads playtime, records, friends, and settings for the account you picked — no bleed between profiles.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-speedrun-checkpoint-death-freeze",
        date: "2026-07-09",
        title: "SpeedRun checkpoint deaths freeze the whole level",
        description:
            "Laser hits on SpeedRun levels with checkpoints now use the same death freeze as other SpeedRun deaths (at least 1 second when lose animation is off). While frozen, lasers, walls, particles, and ball movement stop completely before respawning at the checkpoint.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-local-mobile-fps-ui-cursor-logout-all",
        date: "2026-07-09",
        title: "LOCAL on mobile, FPS layout, UI cursor key, logout all devices",
        description:
            "LOCAL shows again on phones and tablets. FPS stays fixed — low opacity left of Score in-game and top-right in the menu (never beside Return/Pause). Press V (configurable in Keybinds) to unlock the mouse for HUD buttons while the game cursor freezes. SpeedRun death freeze follows lose-animation and freeze settings; other modes retry instantly when configured. Settings → Session adds Log out on all devices.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-square-mode-cards-add-account-local-fix",
        date: "2026-07-09",
        title: "Square mode cards, Add Account flow, LOCAL PC fix",
        description:
            "Mode cards are always square. Switch Account → Add Account signs in or registers a second profile, saves both accounts, and returns you to the one you started from; Return cancels without adding. LOCAL no longer flashes on desktop PC when opening Modes.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-mode-level-cards-switch-account",
        date: "2026-07-09",
        title: "Tap-to-play mode cards, level cards, Switch Account",
        description:
            "Mode cards show only the title — tap to play (Multiplayer keeps its description). SpeedRun and Golf levels use the same card style with name, description, author, and view count. Switch Account beside Log out lists saved accounts; Admin Penalty renamed to Golf.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-solo-slide-local-steer-pattern",
        date: "2026-07-09",
        title: "Individual slide-to-steer uses LOCAL touch model",
        description:
            "Solo modes on iPad now steer like LOCAL multiplayer: per-pointer capture sessions and incremental deltas in the game loop instead of a single global anchor. Multitouch no longer teleports the cursor; a second finger is ignored until the first lifts.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-ipad-slide-steer-touch-paths",
        date: "2026-07-09",
        title: "iPad slide-to-steer fix (Safari + installed PWA)",
        description:
            "Slide-to-steer with the floating joystick off works again on iPad in Safari and in an installed PWA. Safari uses window touch capture only; the home-screen app uses capture-phase touch on the steer pad plus pointer capture without blocking touch.",
        category: "gameplay",
    },
    {
        id: "2026-07-09-pwa-slide-steer-capture",
        date: "2026-07-09",
        title: "Installed PWA slide-to-steer fix (iPad & mobile)",
        description:
            "Slide-to-steer with the floating joystick off now works in an installed home-screen PWA, not only in the Safari browser tab. The touch pad captures pointer moves on drag and uses capture-phase touch delivery in standalone mode.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-speedrun-mobile-trackpad-fix",
        date: "2026-07-07",
        title: "Speedrun mobile trackpad fix",
        description:
            "Fixed mobile Speedrun (solo and multiplayer) slide steering applying movement multiple times per frame. Touch drag now matches Normal and other modes — one trackpad-style update per frame.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-speedrun-touch-local-collisions",
        date: "2026-07-07",
        title: "Speedrun touch fix, LOCAL collisions, hide LOCAL on PC",
        description:
            "Mobile Speedrun (solo and multiplayer) uses the same trackpad or Settings joystick as other modes. LOCAL Speedrun applies wall and laser physics to each cursor. The LOCAL card no longer appears on desktop PC.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-local-score-snake-colorrush-heat",
        date: "2026-07-07",
        title: "LOCAL: score, Snake trail, Color Rush config, moving heat bar",
        description:
            "Score now increases in all LOCAL modes. Snake self-trail immunity is much shorter and only protects your own cursor. Color Rush setup lets you set ball count (default 125) with wide spawn clearance around each player. Heat bars follow each cursor along the screen edge.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-local-polish-end-divisions-snake",
        date: "2026-07-07",
        title: "LOCAL polish: clean end screen, divisions, snake, heat",
        description:
            "Victory and defeat screens show a clean background with no balls or cursors; Return goes back to the LOCAL setup panel. Zone divisions fade in for 1s when the countdown ends, hold 1s, then fade out 1s. Snake trails no longer kill you instantly; heat bars sit on the screen edge. Objects stay frozen during the 3-2-1 countdown.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-local-win-speedrun-joystick",
        date: "2026-07-07",
        title: "LOCAL: win screen, Speedrun fix, joysticks",
        description:
            "When a LOCAL match ends, the game pauses 1.5s then shows the winner (or VICTORY on Speedrun) with Play Again and Return to the panel. Speedrun levels now load lasers and objects correctly. Per-zone joysticks work when enabled in setup.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-local-balls-divisions-steer",
        date: "2026-07-07",
        title: "LOCAL: balls, smoother steer, Divisions toggle",
        description:
            "LOCAL modes now spawn balls correctly. Slide steering uses per-frame deltas so one drag can cross the full screen. Zone lines appear 3s after the countdown (not during it); optional Divisions toggle keeps faint split lines visible all match.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-local-same-device-multiplayer",
        date: "2026-07-07",
        title: "New LOCAL mode (mobile & tablet)",
        description:
            "LOCAL appears under Multiplayer on touch devices only. Set up 2–4 players with names, colors, usernames toggle, joystick or slide-to-steer, and modes from Normal through Sandbox. Each player owns a touch zone on one shared screen; zone lines and names show for 3 seconds at start.",
        category: "gameplay",
    },
    {
        id: "2026-07-07-multitouch-steer-tap",
        date: "2026-07-07",
        title: "Multitouch steer + tap",
        description:
            "Touch control rebuilt around Touch.identifier: the first finger slides the cursor until it lifts; any finger can tap for actions (Aim fire, Hook launch) without moving the cursor. Drag never triggers actions; taps never teleport the cursor.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-ipad-touch-primary-toggle-sounds",
        date: "2026-07-06",
        title: "iPad touch steer + distinct toggle sounds",
        description:
            "Fixed iPad slide steering when Safari registers pointerdown before touchstart (touch.identifier is now the primary finger). Toggle switches skip the generic button beep and play a two-note ascending chirp when ON or descending chirp when OFF.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-touch-pad-sliders-toggle-sounds",
        date: "2026-07-06",
        title: "Touch steer pad + unified sliders & toggle sounds",
        description:
            "Mobile slide steering now uses a full-screen touch pad with linked touch/pointer IDs so the cursor follows your finger in every mode. Sliders use custom cross-browser styling with a soft tick while dragging. Toggle switches play a two-note positive chirp on and two-note negative chirp off (shorter than Menu/Pause).",
        category: "gameplay",
    },
    {
        id: "2026-07-06-touch-session-steer",
        date: "2026-07-06",
        title: "Mobile slide steer session fix",
        description:
            "Touch drag now moves the cursor using a session anchor (total finger offset from touch-down) instead of fragile per-frame deltas. Fixes identifier vs pointerId mismatches, registers Aim/Hook on touchstart, and keeps the primary-finger-only rule.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-touchmove-steer-primary",
        date: "2026-07-06",
        title: "Mobile slide steer via touchmove",
        description:
            "Touch drag now moves the cursor through touchmove coordinates, not only pointermove (which mobile browsers often block). Primary finger still steers; a second finger can tap for actions without teleporting the cursor.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-touch-steer-overload-play-area",
        date: "2026-07-06",
        title: "Mobile slide steer + Overload play area",
        description:
            "Dragging with your first finger moves the cursor again on mobile in every mode (browser pan gestures no longer block pointer moves). Overload Bigger/Smaller play area now literally expands or shrinks the arena: new edge bands start empty and fill as balls drift in; smaller area zooms sprites up, bigger area zooms them down.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-mobile-slide-steer-fix",
        date: "2026-07-06",
        title: "Mobile slide steer fix",
        description:
            "Dragging with your first finger moves the cursor again on mobile in every mode. Second-finger slides are still ignored; either finger can tap for actions (Hook fire, Aim shot) when the press is not a drag. Fixed lost touch capture cancelling movement mid-gesture.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-mobile-cursor-invert-return",
        date: "2026-07-06",
        title: "Mobile cursor fix, Invert Sidebar Return align",
        description:
            "Touch steering works again on mobile while keeping the primary-finger rule (second finger taps for actions only). With Invert Sidebar on, Return sits on the left at the same height as the Menu/Close button.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-return-outside-primary-touch",
        date: "2026-07-06",
        title: "Return stays outside menu, primary-finger touch",
        description:
            "Return is always fixed outside the sidebar (still aligned with Menu/Close when Invert Sidebar is on). On mobile the cursor only follows the first finger after all touches lift; a second finger can tap for mode actions (Hook fire, Aim shot) without moving or teleporting the cursor.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-return-hook-touch-dropdowns",
        date: "2026-07-06",
        title: "Return dock, multi-catch Hook, touch fix, dropdowns",
        description:
            "Return matches the compact fixed size: docked inside the sidebar below Close when the menu is open (left sidebar), below Menu when closed, and aligned with Menu/Close when Invert Sidebar is on. Hook now passes through balls to grab several per shot; it retracts on walls and only punishes red balls when they reach your cursor on the way back (or if any red is still attached at the end). Mobile no longer teleports the cursor with a second finger in any mode. Custom dropdowns hide horizontal scroll and shrink long labels.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-hud-layout-hook-accessibility",
        date: "2026-07-06",
        title: "HUD layout options, FPS anchor, Hook fixes",
        description:
            "Accessibility adds Invert Return and Pause, and Invert Sidebar (right-side menu). Return docks inside the sidebar below Close when the sidebar is on the left; with Invert Sidebar it stays fixed on the left. FPS shows as “FPS: X” beside Return (or beside Pause when inverted). Hook: fire with left-click while aiming with right-click on PC; mobile no longer teleports the cursor when shooting while sliding.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-show-fps-accessibility",
        date: "2026-07-06",
        title: "Accessibility: Show FPS",
        description:
            "Settings → Accessibility adds Show FPS. When enabled, choose Home, Game, or Always for where the counter appears. Displays as “FPS: X” in your text colour, updating every half second.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-stats-dropdown-hook-polish",
        date: "2026-07-06",
        title: "Stats dropdown fix, scrollable menus, Hook polish",
        description:
            "Stats level cards show one custom dropdown each (all levels per mode) without a duplicate native picker. Dropdown text uses a clearer readable size with comfortable padding, and long lists scroll inside the panel. Hook: right-click no longer snaps the laser; you can fire with left-click while aiming. Mobile Hook tap-to-fire works again.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-hook-aim-dropdowns-touch",
        date: "2026-07-06",
        title: "Hook aim rework, dropdown fixes, mobile touch",
        description:
            "Hook: on PC hold right-click to aim the laser without moving the cursor; left-click fires. On mobile use the right-side aim joystick and tap anywhere to shoot. Second-finger touches no longer teleport the cursor. Custom dropdowns now cover Stats level pickers and float above Rankings text. Dropdown panels render in a fixed overlay so they are not clipped by scroll areas.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-hook-views-dropdowns-recent-touch",
        date: "2026-07-06",
        title: "Hook fixes, custom dropdowns, Recently Played filter",
        description:
            "Hook global views now count correctly. Hook aim uses sub-step collision so the laser matches hits; on mobile a second finger launches the hook without moving the cursor. All dropdowns use the in-game custom picker with UI sounds. Modes filter adds Recently Played (local play history).",
        category: "gameplay",
    },
    {
        id: "2026-07-06-overload-score-and-play-area",
        date: "2026-07-06",
        title: "Overload: ×2/÷2 Score and real play-area scaling",
        description:
            "Overload pick options no longer include +50% or −25% score rate. New buff ×2 Score doubles your current score; debuff ÷2 Score halves it. Bigger play area now shrinks the cursor and balls (and edge padding) for more room; smaller play area enlarges them — HUD text and buttons stay the same size.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-hook-mode-and-remove-preview",
        date: "2026-07-06",
        title: "New Hook mode; mode Preview removed",
        description:
            "Hook: a laser shows your last move direction — click or tap to launch a hook along that line. Catch normal balls (+1 after a 2s pull-back); red balls or touching any ball with the cursor ends the run. Starts with 15 normal and 15 red balls; every 15s spawns 5 normal and 10 red. The animated Preview on mode cards and its menu button are removed; use Description for full rules.",
        category: "gameplay",
    },
    {
        id: "2026-07-06-ui-sounds-and-ranking-podium",
        date: "2026-07-06",
        title: "UI sounds and ranking podium styling",
        description:
            "Buttons and toggles now play subtle hover and on/off sounds across the interface (respecting Sounds and UI Volume in Settings). Rankings highlight places 1–3 with gold, silver, and bronze tones and increasing glow.",
        category: "visual",
    },
    {
        id: "2026-07-06-golf-mode-rename-and-rules",
        date: "2026-07-06",
        title: "Penalty mode renamed to Golf",
        description:
            "Penalty is now Golf. Your cursor passes through the ball while it is moving; solid walls no longer block the ball. Laser hits reset hits and progress when no checkpoint was reached. SpeedRun resets the timer on death without a checkpoint. Death now freezes play for 1 second regardless of the Freeze Game setting.",
        category: "gameplay",
    },
    {
        id: "2026-06-20-penalty-mode",
        date: "2026-06-20",
        title: "New mode: Golf (formerly Penalty)",
        description:
            "Guide a ball through SpeedRun-style laser mazes with free cursor movement. Strike the ball to move it — fewer hits to the goal wins. Separate levels and rankings per stage.",
        category: "gameplay",
    },
    {
        id: "2026-06-18-game-over-run-score-and-layout",
        date: "2026-06-18",
        title: "Game Over shows your run score and a larger layout",
        description:
            "Game Over now lists Score (or Level / Time) from the run you just lost above Best Score, with a larger GAME OVER title, centered stats, and a Play Again button styled like Home START.",
        category: "visual",
    },
    {
        id: "2026-06-18-speedrun-solid-wall-tunneling-fix",
        date: "2026-06-18",
        title: "SpeedRun solid walls block fast cursor movement",
        description:
            "Solid walls in SpeedRun use tighter continuous collision so the cursor cannot pass through them at high speed, including moving walls and portal paths.",
        category: "bug-fix",
    },
    {
        id: "2026-06-18-admin-player-stats-screen",
        date: "2026-06-18",
        title: "Moderation: per-player stats screen",
        description:
            "Admins can open Delete stats from the moderation search bar to view and edit playtime, deaths, achievements, and records — with Change and Delete on each row.",
        category: "gameplay",
    },
    {
        id: "2026-06-18-account-logout-clears-local-data",
        date: "2026-06-18",
        title: "Logout clears local stats and settings until next sign-in",
        description:
            "Signing out immediately clears local playtime, presets, and settings on this device. Signing into another account loads that user's synced data instead of mixing with the previous session.",
        category: "bug-fix",
    },
    {
        id: "2026-06-17-aim-waves-and-auto-retry",
        date: "2026-06-17",
        title: "AIM waves, bigger balls, Auto Retry fix",
        description:
            "AIM now has 30 larger balls. Clearing the field pauses 3s (timer full), then new balls fade in over 3s before the next wave. Auto Retry ON skips Game Over; OFF shows it. Cursor movement is smoother on touch.",
        category: "gameplay",
    },
    {
        id: "2026-06-17-aim-mode-tuning",
        date: "2026-06-17",
        title: "AIM mode tuning",
        description:
            "Golden target mode with a 2-second timer and slimmer countdown bar. Hit the golden ball to score; wrong shot or timeout ends the run.",
        category: "gameplay",
    },
    {
        id: "2026-06-17-aim-mode",
        date: "2026-06-17",
        title: "New mode: AIM",
        description:
            "One golden target among moving balls — click or tap it before time runs out. Normal balls pass through each other; only the golden ball bounces. Wrong shot or timeout ends the run.",
        category: "gameplay",
    },
    {
        id: "2026-06-16-settings-os-style-redesign",
        date: "2026-06-16",
        title: "Settings: cleaner OS-style layout",
        description:
            "Settings now uses compact vertical lists like modern phone and desktop system preferences — grouped rows, toggles on the right, and smoother accordion open/close animations. The right sidebar and every option stay the same.",
        category: "visual",
    },
    {
        id: "2026-06-16-cursor-teleport-fix-copy-paste-toast",
        date: "2026-06-16",
        title: "Smoother PC cursor; Copy/Paste toasts",
        description:
            "PC cursor movement no longer jumps from stray pointer spikes after focus or lock. Settings Copy and Paste show a blurred top toast for 1.5s with a short positive chirp.",
        category: "bug-fix",
    },
    {
        id: "2026-06-16-settings-cards-independent-height",
        date: "2026-06-16",
        title: "Settings cards keep their own height",
        description:
            "Each Settings card now sizes to its own content instead of stretching to match taller neighbours in the same row. Grid spacing still keeps text and controls from overlapping.",
        category: "settings",
    },
    {
        id: "2026-06-16-toggle-switch-ui",
        date: "2026-06-16",
        title: "Toggle switches replace ON/OFF buttons",
        description:
            "Settings, Sandbox, D-Pad, and multiplayer booleans now use a sliding switch with the button colour when on and a transparent track when off — no more ON/OFF labels.",
        category: "visual",
    },
    {
        id: "2026-06-16-copy-toast-mobile-audio",
        date: "2026-06-16",
        title: "Copy toast and louder mobile audio",
        description:
            "Settings Copy shows a blurred “Copied” banner at the top instead of renaming the button. Mobile touch devices get a master audio boost so music and SFX stay audible without breaking volume sliders.",
        category: "settings",
    },
    {
        id: "2026-06-16-dpad-simultaneous-presses",
        date: "2026-06-16",
        title: "D-Pad accepts every button at once",
        description:
            "You can hold multiple D-Pad directions at the same time — even all four cardinals — so diagonal movement works with Diagonal Direction off.",
        category: "gameplay",
    },
    {
        id: "2026-06-16-settings-slider-type-value",
        date: "2026-06-16",
        title: "Type slider values in Settings",
        description:
            "Click the number beside any Settings slider — Music, WASD sensitivity, brightness, colour channels, and more — to type an exact value. Limits stay the same as the slider max.",
        category: "settings",
    },
    {
        id: "2026-06-16-settings-copy-fix",
        date: "2026-06-16",
        title: "Settings Copy works again",
        description:
            "Copy no longer crashes on a missing D-Pad helper and reliably writes the full settings JSON to your clipboard, with a textarea fallback when the browser blocks clipboard API access.",
        category: "bug-fix",
    },
    {
        id: "2026-06-16-settings-paste-fix",
        date: "2026-06-16",
        title: "Settings Paste accepts copied JSON again",
        description:
            "Paste now reads the wrapped Copy format and legacy flat JSON, coercing numbers and booleans so a copied snapshot applies without format errors.",
        category: "bug-fix",
    },
    {
        id: "2026-06-16-settings-copy-complete-cursor-fluid",
        date: "2026-06-16",
        title: "Settings Copy exports every option; smoother PC cursor",
        description:
            "Copy now writes a full formatted JSON snapshot of all colours, toggles, sliders, music tracks, keybinds, and D-Pad options straight from the Settings UI. PC cursor movement no longer caps fast flicks or jumps after alt-tab.",
        category: "settings",
    },
    {
        id: "2026-06-16-sidebar-active-dot-gradient",
        date: "2026-06-16",
        title: "Sidebar active dot matches button gradient",
        description:
            "The small dot beside the active sidebar panel now uses the same button gradient as the nav buttons, so it stays visible even when both the background and button color are very dark.",
        category: "visual",
    },
    {
        id: "2026-06-16-settings-copy-all-keys",
        date: "2026-06-16",
        title: "Settings Copy exports every option",
        description:
            "The Settings Copy button now writes a complete JSON snapshot of all appearance, sound, accessibility, keybind, and D-Pad options — including values still at their defaults.",
        category: "settings",
    },
    {
        id: "2026-06-16-account-switch-isolation",
        date: "2026-06-16",
        title: "Account switch no longer leaks stats or settings",
        description:
            "Signing into a different account now loads only that account's cloud playtime, stats, settings, and sandbox presets. Guest or previous-account local data is cleared before sync instead of being merged in.",
        category: "bug-fix",
    },
    {
        id: "2026-06-16-cursor-no-smoothing",
        date: "2026-06-16",
        title: "PC-perfect cursor movement",
        description:
            "The in-game cursor now follows your mouse 1:1 with zero easing in every mode. Sandbox Smooth Cursor no longer adds lag; Roulette only slows pointer follow during the sens_slow effect.",
        category: "gameplay",
    },
    {
        id: "2026-06-16-freeze-game-seconds",
        date: "2026-06-16",
        title: "Custom Freeze Game duration",
        description:
            "With Lose animation OFF, Freeze Game shows a Seconds field (0.1–60) next to the toggle. Set how long the run stays frozen before Game Over when the split animation is disabled.",
        category: "settings",
    },
    {
        id: "2026-06-16-dpad-customize-marquee-grid",
        date: "2026-06-16",
        title: "D-Pad Customize: marquee select, undo/redo, snap grid",
        description:
            "In D-Pad Customize, drag on empty space to box-select buttons and move them together. Undo and Redo are in the toolbar. Grid toggle snaps every button to a visible cell sized to match your buttons.",
        category: "settings",
    },
    {
        id: "2026-06-16-dpad-customize-multi-opacity",
        date: "2026-06-16",
        title: "D-Pad Customize multi-select and opacity",
        description:
            "Customize adds an Opacity slider for all D-Pad buttons and multi-select drag for grouped moves. D-Pad button labels can no longer be text-selected.",
        category: "settings",
    },
    {
        id: "2026-06-16-mobile-dpad-customize",
        date: "2026-06-16",
        title: "Mobile D-Pad customize and settings cleanup",
        description:
            "D-Pad Customize opens a live sandbox: drag buttons or the grip handle to reposition, pinch anywhere to resize all buttons, and switch between three layouts. The grip handle only appears in Customize — not during normal play. Settings → Mobile controls now holds D-Pad and Joystick; Diagonal Direction and Customize are on the D-Pad card.",
        category: "settings",
    },
    {
        id: "2026-06-16-mobile-dpad-overhaul",
        date: "2026-06-16",
        title: "Mobile D-Pad overhaul",
        description:
            "Touch D-Pad got fluid slide input, optional diagonal corner buttons, three position layouts, and per-button offsets saved to your device. Mode popularity counts a view after 3 seconds on the Modes screen.",
        category: "settings",
    },
    {
        id: "2026-06-14-counter-mode",
        date: "2026-06-14",
        title: "New Counter mode",
        description:
            "Counter starts with 100 numbered balls (1–100). Touch them in order: wrong ball or letting the 5-second timer hit zero ends the run. Each correct ball adds +1 score. Clear the field for a 2-second pause, then 100 fresh balls respawn away from your cursor. Ball speed never increases.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-hunter-zone-patrol",
        date: "2026-06-14",
        title: "Hunter zone patrol and activation",
        description:
            "Red hunters in Hunter no longer all chase you at once. They patrol assigned zones across the map and only activate when you get close — then nearby hunters hunt as a coordinated pack. More hunters means more zones spread across the arena.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-hunter-spawns-and-pack-ai",
        date: "2026-06-14",
        title: "Hunter spawn balance and pack AI",
        description:
            "Hunter now adds 10 normal balls and 2 red hunters every 250 score. Red hunters coordinate as a pack: some chase directly, others block escape routes, and the rest spread around you — with tighter teamwork as their count grows.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-hunter-mode",
        date: "2026-06-14",
        title: "New Hunter mode",
        description:
            "Hunter starts with 24 normal balls. Every 250 score, a bright red hunter ball spawns far from you and chases your cursor, bouncing off walls. Normal and hunter balls both end the run on contact.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-snake-apple-spin",
        date: "2026-06-14",
        title: "Snake apples spin while moving",
        description:
            "Moving apples in singleplayer Snake now rotate in place as they bounce. Movement and collisions are unchanged — visual only.",
        category: "visual",
    },
    {
        id: "2026-06-14-moderation-timeout-tools",
        date: "2026-06-14",
        title: "Moderation timeout durations and adjust modal",
        description:
            "Admins can set timeout length with s, m, h, or d (e.g. 30s, 5m, 2h, 5d). Reduce opens a modal to subtract time or set remaining time. The Moderation section scrolls when the list is long.",
        category: "settings",
    },
    {
        id: "2026-06-14-modes-picker-overhaul",
        date: "2026-06-14",
        title: "Modes picker: pin, menu, and live popularity",
        description:
            "Pin modes to duplicate their card at the top. Each card has a ⋮ menu: Description, See In Ranking, and Pin/Unpin. Best Score syncs from Rankings when signed in. Popular sort uses global visit counts (refreshes every 5 s). Search and sort sit on the same row as section titles.",
        category: "visual",
    },
    {
        id: "2026-06-14-quick-restart-and-ui-fixes",
        date: "2026-06-14",
        title: "Quick Restart and playability fixes",
        description:
            "Quick Restart (triple-click on PC or keybind) now waits for the lose animation and auto-restarts instead of dropping you on Game Over. RETURN stays visible during death animation. iPad gameplay canvas sizing is fixed so the field is not squashed.",
        category: "bug-fix",
    },
    {
        id: "2026-06-14-heat-mode",
        date: "2026-06-14",
        title: "New Heat mode",
        description:
            "Heat tracks how fast you move the cursor: stay too still and you freeze; move too frantically and you burn. A temperature gauge tints your cursor blue→white→red, with a side bar on desktop. 50 balls to start; +50 every 500 score.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-mirror-mode",
        date: "2026-06-14",
        title: "New Mirror mode",
        description:
            "Mirror adds a reflected twin cursor across the screen center. You control the primary cursor only — if either cursor touches a ball, the run ends. Same ball rules as Normal (1 ball, +50 every 500, bounce boost).",
        category: "gameplay",
    },
    {
        id: "2026-06-14-overload-mode",
        date: "2026-06-14",
        title: "New Overload mode",
        description:
            "Every 15 seconds, choose a buff and a curse that stack for the rest of the run. Manage lives, shrinking play area, faster balls, and more. Gameplay pauses during each pick overlay.",
        category: "gameplay",
    },
    {
        id: "2026-06-14-account-moderation-timeouts",
        date: "2026-06-14",
        title: "Account timeouts in Moderation",
        description:
            "Admins with Moderation permission can time out accounts from the Admin Panel. Timed-out players see a block screen until the timeout expires or an admin clears it. Apply, extend, reduce, or remove timeouts from the user search and active list.",
        category: "settings",
    },
    {
        id: "2026-06-13-stats-sync-ranking",
        date: "2026-06-13",
        title: "Stats synced with Rankings",
        description:
            "Stats records now match your Rankings entries when signed in. Deleting a record in Moderation clears it everywhere. Stats adds Deaths and Favorite Mode (most-played mode).",
        category: "gameplay",
    },
    {
        id: "2026-06-13-snake-moving-apples",
        date: "2026-06-13",
        title: "Snake singleplayer — moving apples",
        description:
            "Singleplayer Snake now uses moving apples instead of balls. Touch an apple for +1 score; apples bounce off your trail. Hitting your trail or the walls still ends the run. Multiplayer Snake is unchanged.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-modes-search-sort",
        date: "2026-06-13",
        title: "Modes search and sort filters",
        description:
            "The Modes screen has a search bar (top right, next to Singleplayer) for instant filtering. Filter by Newest, Oldest, or Popular — popularity uses local play counts per mode.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-color-rush",
        date: "2026-06-13",
        title: "Color Rush singleplayer mode",
        description:
            "New mode: 350 balls in five colors, cursor color cycles every 5 seconds. Collect matching balls (+1 score); wrong color ends the run. Balls respawn after clearing a wave; ball-to-ball collisions enabled.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-lobby-host-transfer",
        date: "2026-06-13",
        title: "Transfer host in multiplayer lobby",
        description:
            "The room host can pass host to another player with Make host next to Kick. Only one host at a time; works in lobby only.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-mp-ball-spawn-clearance",
        date: "2026-06-13",
        title: "Multiplayer balls avoid all cursors",
        description:
            "Balls no longer spawn within clearance range of any alive player cursor in multiplayer Normal, WASD, Sandbox, and Snake.",
        category: "bug-fix",
    },
    {
        id: "2026-06-13-snake-mp-trail-collision",
        date: "2026-06-13",
        title: "Snake MP trail collision fix",
        description:
            "Snake multiplayer uses swept collision on every trail segment so high-speed movement cannot tunnel through trails. Hitting any trail (yours or another player's) eliminates you and switches to spectate.",
        category: "bug-fix",
    },
    {
        id: "2026-06-13-mp-end-screens",
        date: "2026-06-13",
        title: "Multiplayer end screens: Play Again and Next Level",
        description:
            "All multiplayer modes show Play Again on the results screen. Speedrun multiplayer also offers Next Level for the host after FFA or Co-op races.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-circular-start-button",
        date: "2026-06-13",
        title: "Circular START button on Home",
        description: "The Home START button is now a true circle on desktop and mobile instead of a stretched pill.",
        category: "visual",
    },
    {
        id: "2026-06-13-sidebar-navigation-updates",
        date: "2026-06-13",
        title: "Sidebar navigation updates",
        description:
            "On PC, Up/Down arrow keys cycle sidebar panels (Credits last; Admin Panel excluded). The active panel shows a small dot outside the button. Focus outlines on sidebar buttons were removed.",
        category: "visual",
    },
    {
        id: "2026-06-13-pause-spawn-timer-freeze",
        date: "2026-06-13",
        title: "Pause freezes Combo and Roulette spawns",
        description:
            "While the game is paused, Combo and Roulette no longer advance spawn timers, so extra balls do not appear after you unpause.",
        category: "bug-fix",
    },
    {
        id: "2026-06-13-combo-mode",
        date: "2026-06-13",
        title: "New Combo mode",
        description:
            "Combo is a singleplayer mode where balls spawn on a fixed timer. Chain near-misses to build a combo multiplier and score faster.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-triple-tap-restart",
        date: "2026-06-13",
        title: "Triple-tap quick restart on PC",
        description: "During gameplay on PC, triple-click anywhere on the canvas to restart the current run instantly.",
        category: "gameplay",
    },
    {
        id: "2026-06-13-ball-collision-tunneling-fix",
        date: "2026-06-13",
        title: "Ball collision tunneling fix",
        description:
            "High-speed cursor movement no longer slips through balls; collision checks subsample movement so hits register reliably.",
        category: "bug-fix",
    },
    {
        id: "2026-06-11-sandbox-return-and-mp-lobby-music",
        date: "2026-06-11",
        title: "Sandbox Return fix and lobby music",
        description:
            "Return from singleplayer Sandbox customization goes back to Modes instead of a multiplayer lobby. Menu music now plays in multiplayer lobby and room screens.",
        category: "bug-fix",
    },
    {
        id: "2026-06-11-friends-by-username",
        date: "2026-06-11",
        title: "Add friends by username",
        description:
            "In Friends you can send a request with a player username or account email. Usernames must match exactly (letters, numbers, underscore).",
        category: "settings",
    },
    {
        id: "2026-06-11-snake-visible-border-and-mp-balls",
        date: "2026-06-11",
        title: "Snake: visible border and MP Balls toggle",
        description:
            "Snake draws the play-area border in your trail color — touch it and you lose (singleplayer and multiplayer). Multiplayer Snake adds a Balls ON/OFF lobby setting; permanent trails are unchanged.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-highway-mp-client-rebuild",
        date: "2026-06-11",
        title: "Highway multiplayer client rebuild",
        description:
            "Highway MP uses a dedicated client module with seeded simulation plus server snapshots so the road, obstacles, and collisions render reliably for every player and spectator.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-snake-trails-highway-mp-friend-rooms",
        date: "2026-06-12",
        title: "Snake trails, Highway MP, and friend rooms",
        description:
            "Snake MP shows every player's permanent trail including your own. Highway multiplayer syncs road and obstacles from the server again. Create Room opens an invite screen; friends see your lobby under Join Room.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-snake-mp-trails-no-countdown",
        date: "2026-06-12",
        title: "Snake MP: move from the start, trails after 3s",
        description:
            "In multiplayer Snake you can move immediately when the match starts. Permanent synced trails appear after 3 seconds — touch any trail (yours or anyone else's) and you're out. Also fixes abrupt cursor jumps on PC.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-multiplayer-snake-mode",
        date: "2026-06-11",
        title: "Multiplayer Snake mode",
        description:
            "Snake is now in multiplayer. Every cursor leaves a synced permanent trail — touch any trail (yours or anyone else's) and you're out. FFA or Co-op. +50 balls every 500 score.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-snake-singleplayer-mode",
        date: "2026-06-11",
        title: "New mode: Snake (singleplayer)",
        description:
            "Snake is a new singleplayer mode. Your cursor leaves a permanent trail — avoid your own path, the play area walls, and bouncing balls. Every 500 score adds 55 more balls. Singleplayer only; not in multiplayer.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-mp-highway-client-sim-speedrun-results",
        date: "2026-06-11",
        title: "Highway MP client sim and Speedrun results fix",
        description:
            "Highway multiplayer now runs the same seeded road simulation locally so the track, obstacles, and remote cursors stay in sync. Speedrun race results stop the match immediately and show the leaderboard after 2 seconds; Return closes it for everyone.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-mp-highway-results-spectate-cursor",
        date: "2026-06-11",
        title: "Highway MP fix, Speedrun results Return, spectate cursor",
        description:
            "Highway multiplayer syncs road, obstacles, and remote players again. Speedrun race results use Return for everyone; the in-game finisher list hides when the race ends. PC spectate keeps the system cursor visible.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-mp-highway-sync-speedrun-spectate",
        date: "2026-06-12",
        title: "Highway MP sync, Speedrun spectate, and lobby Return",
        description:
            "Highway multiplayer now syncs vertical world position correctly for other players. Speedrun MP shows finisher times, spectate controls, and results after a 2s delay with Back for everyone. Return leaves the match to lobby; Leave is hidden while playing.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-multiplayer-speedrun-race-ffa",
        date: "2026-06-12",
        title: "Multiplayer Speedrun race (FFA)",
        description:
            "Speedrun multiplayer skips FFA/Co-op selection and always runs as FFA. A 3-second countdown blocks movement at start. Each player runs the level locally (points, lasers, walls). When everyone reaches the goal, a results table shows rank, time, and device.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-multiplayer-fixes-highway-sounds-cursor",
        date: "2026-06-12",
        title: "Multiplayer fixes: Highway touch, card beeps, cursor",
        description:
            "Highway multiplayer on mobile uses joystick or trackpad like Normal (not D-pad). Mode card taps play the UI beep without a flash. The mouse cursor reappears when the match ends, not when you die in FFA.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-multiplayer-mode-parity-sandbox-highway",
        date: "2026-06-12",
        title: "Multiplayer mode parity: WASD, Sandbox, Highway",
        description:
            "WASD works in multiplayer on PC. Sandbox host settings sync fully (cursor smooth/size, ball speed, etc.). Highway uses world-space cursors with smoother obstacle sync.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-multiplayer-trails-modes-lobby-sync",
        date: "2026-06-12",
        title: "Multiplayer trails, modes, and lobby sync",
        description:
            "Trails sync for all players (respecting Trails OFF). Four game modes: Speedrun, WASD, Sandbox, Highway. No pause in multiplayer. Everyone sees the host pick FFA or Co-op.",
        category: "gameplay",
    },
    {
        id: "2026-06-12-multiplayer-smooth-interpolation",
        date: "2026-06-12",
        title: "Smoother multiplayer movement",
        description:
            "Remote players and balls now interpolate between server snapshots for fluid motion. Death handling is more reliable with faster position updates to the server.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-instant-cursor-response-in-every-mode",
        date: "2026-06-11",
        title: "Instant cursor response in every mode",
        description:
            "The in-game cursor tracks your mouse 1:1 with no smoothing or lag in all modes.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-ten-continuous-arcade-music-loops",
        date: "2026-06-11",
        title: "Ten continuous arcade music loops",
        description:
            "Menu and in-game music use ten chip-style loops with seamless four-bar patterns.",
        category: "settings",
    },
    {
        id: "2026-06-11-smooth-wall-scroll-to-match-settings-feel",
        date: "2026-06-11",
        title: "Smoother Wall scrolling",
        description:
            "The Wall page scrolls with the same smooth wheel feel as Settings and other sidebar sections.",
        category: "visual",
    },
    {
        id: "2026-06-11-shift-return-button-when-sidebar-is-open",
        date: "2026-06-11",
        title: "RETURN moves aside when the sidebar opens",
        description:
            "The in-game RETURN button shifts so it stays visible and clickable while the menu sidebar is open.",
        category: "visual",
    },
    {
        id: "2026-06-11-refresh-wall-live-data-silently-without-replayin",
        date: "2026-06-11",
        title: "Wall live updates without animation replay",
        description:
            "Polls, counters, and stats on Wall refresh quietly in the background without replaying block enter animations.",
        category: "visual",
    },
    {
        id: "2026-06-11-wall-page-in-sidebar",
        date: "2026-06-11",
        title: "Wall page in the sidebar",
        description:
            "Open Wall from the menu to browse live stats, polls, counters, featured presets, speedruns, and community blocks.",
        category: "visual",
    },
    {
        id: "2026-06-10-menu-and-game-brightness-sliders-0-100",
        date: "2026-06-10",
        title: "Menu and Game brightness sliders (0–100)",
        description:
            "Menu Bright and Game Bright in Settings use 0–100 sliders so you can fine-tune how light or dark each screen looks.",
        category: "settings",
    },
    {
        id: "2026-06-10-replace-dark-mode-toggles-with-bright-sliders-an",
        date: "2026-06-10",
        title: "Bright sliders replace dark-mode toggles",
        description:
            "Dark mode toggles are now Bright sliders for the menu and game canvas. UI chrome follows your Text Color setting.",
        category: "settings",
    },
    {
        id: "2026-06-11-darkness-shrink-cap-and-danger-timing",
        date: "2026-06-11",
        title: "Darkness shrink cap and earlier danger cues",
        description:
            "Vision shrink speed now stops increasing after 4000 score. Danger zoom and tension audio kick in a little sooner when your lit area gets small.",
        category: "gameplay",
    },
    {
        id: "2026-06-11-darkness-vision-balance",
        date: "2026-06-11",
        title: "Darkness vision balance update",
        description:
            "Points now add a small bump to your current vision radius instead of a fixed restore. Shrink speed ramps up smoothly with score and caps at 4000 points.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-settings-background-inside-vision",
        date: "2026-06-10",
        title: "Darkness uses your game background inside the light",
        description:
            "Inside the vision circle, Darkness now matches your Settings game background (color and dark-mode treatment). Everything outside the circle stays pure black.",
        category: "visual",
    },
    {
        id: "2026-06-10-darkness-vision-clip-and-tuning",
        date: "2026-06-10",
        title: "Darkness vision clip and faster shrink",
        description:
            "Balls, points, and effects only render inside the lit circle; score text stays visible. The circle starts smaller and shrinks faster than before.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-danger-zoom-and-audio",
        date: "2026-06-10",
        title: "Darkness danger zoom and tension audio",
        description:
            "When vision gets very small, the camera zooms smoothly toward your cursor and a tense layer fades in while game music ducks down. Both recover quickly once you collect points.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-collectible-points",
        date: "2026-06-10",
        title: "Darkness collectible vision points",
        description:
            "Three glowing points are always on the map. Each pickup adds a little to your current vision; a new point spawns immediately at a random spot.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-ball-scaling",
        date: "2026-06-10",
        title: "Darkness ball scaling",
        description: "Darkness starts with 5 balls and adds 5 more every 500 score points.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-rankings-and-stats",
        date: "2026-06-10",
        title: "Darkness rankings and personal bests",
        description:
            "Darkness scores appear in Rankings, Stats, and cloud account sync when signed in.",
        category: "gameplay",
    },
    {
        id: "2026-06-10-darkness-mode",
        date: "2026-06-10",
        title: "New Darkness mode",
        description:
            "Play Darkness from MODES: dodge balls in a shrinking circle of light around your cursor. If vision reaches zero, it is game over.",
        category: "gameplay",
    },
    {
        id: "2026-06-09-news-category-filter",
        date: "2026-06-09",
        title: "News category filter",
        description: "Filter updates by Newest, Oldest, Bug Fixes, Gameplay, Settings, or Visual.",
        category: "visual",
    },
    {
        id: "2026-06-09-news-sidebar-and-home-setting",
        date: "2026-06-09",
        title: "News in sidebar and Settings toggle",
        description: "Open News from the sidebar under Social. Use Settings → News in Home to show or hide the Home slide-out panel.",
        category: "settings",
    },
    {
        id: "2026-06-09-news-feed-expanded",
        date: "2026-06-09",
        title: "Expanded in-game News feed",
        description: "News lists player-visible updates in English with Load More pagination on Home and in the sidebar screen.",
        category: "visual",
    },
    {
        id: "2026-06-09-news-home-slide-panel",
        date: "2026-06-09",
        title: "Home News slide-out panel",
        description: "A collapsible News panel on the right edge of Home with a tab to open and close it.",
        category: "visual",
    },
];
